import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/category',
            name: 'category',
            component: () => import('./views/category/CategoryList')
        },
        {
            path: '/category/new',
            name: 'category-new',
            component: () => import('./views/category/CategoryEdit')
        },
        {
            path: '/category/edit/:id',
            name: 'category-edit',
            component: () => import('./views/category/CategoryEdit')
        },
        {
            path: '/product',
            name: 'product',
            component: () => import('./views/product/ProductList')
        },
        {
            path: '/product/new',
            name: 'product-new',
            component: () => import('./views/product/ProductEdit')
        },
        {
            path: '/product/edit/:id',
            name: 'product-edit',
            component: () => import('./views/product/ProductEdit')
        },
        {
            path: '/region',
            name: 'region',
            component: () => import('./views/region/RegionList')
        },
        {
            path: '/region/new',
            name: 'region-new',
            component: () => import('./views/region/RegionEdit')
        },
        {
            path: '/region/edit/:id',
            name: 'region-edit',
            component: () => import('./views/region/RegionEdit')
        },
        {
            path: '/message',
            name: 'message',
            component: () => import('./views/message/MessageList')
        },
        {
            path: '/sms-code',
            name: 'sms-code',
            component: () => import('./views/sms-code/SmsCodeList')
        },
        {
            path: '/user',
            name: 'user',
            component: () => import('./views/user/UserList')
        },
        {
            path: '/user/new',
            name: 'user-new',
            component: () => import('./views/user/UserEdit')
        },
        {
            path: '/user/edit/:id',
            name: 'user-edit',
            component: () => import('./views/user/UserEdit')
        },
        {
            path: '/report',
            name: 'report',
            component: () => import('./views/report/Report')
        }
    ]
})
